import { HasFeature } from '@/components/Atoms/Permissions'
import { EditQueueFeature } from '@/lib/features'
import { buildPath } from '@/routes'
import { Navigate, Outlet } from 'react-router'

export function EditQueueLayout() {
  return (
    <HasFeature
      feature={EditQueueFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Outlet />
    </HasFeature>
  )
}
